import { combineReducers } from "redux";
import store from "./store";
import auth from "./auth";
import userProfile from "./userProfile";
import logo from "./logo";
import logoutModal from "./logoutModal";

export default combineReducers({
	auth,
	userProfile,
	store,
	logo,
	logoutModal,
});
